// ── Smelt Recipes ──────────────────────────────────────────────────────────────
//
// Gate fields (at most one per recipe):
//   unlockResearch: "refineryN"  — requires that refinery research level
//   unlockMat: "matId"           — requires the player to have discovered that base mat
//
// outputType: "material" (default) | "fuel"
//   "fuel" recipes increment the player's fuel tank instead of materials inventory.

export const SMELT_RECIPES = [

  // ══════════════════════════════════════════════════════════════════════════
  // TIER 1 REFINED — Unlocked by refinery1
  // Inputs are starter base mats only (copper, hull_debris, glass_shard).
  // ══════════════════════════════════════════════════════════════════════════

  { id: "r1",  name: "Refine Fuel",         output: "fuel",             outputQty: 1, time: 8,
    inputs: [{ id: "copper", qty: 10 }, { id: "glass_shard", qty: 6 }],
    unlockResearch: "refinery1" },

  { id: "r2",  name: "Smelt Metal Alloy",   output: "metal_alloy",      outputQty: 1, time: 10,
    inputs: [{ id: "copper", qty: 10 }, { id: "hull_debris", qty: 10 }],
    unlockResearch: "refinery1" },

  { id: "r3",  name: "Forge Synth Alloy",   output: "synth_alloy",      outputQty: 1, time: 12,
    inputs: [{ id: "hull_debris", qty: 8 }, { id: "glass_shard", qty: 8 }],
    unlockResearch: "refinery1" },

  // ══════════════════════════════════════════════════════════════════════════
  // TIER 1 COMPONENTS — Unlocked by refinery2 (Forge Level 5)
  // ══════════════════════════════════════════════════════════════════════════

  { id: "r4",  name: "Forge Thermal Core",      output: "thermal_core",      outputQty: 1, time: 20,
    inputs: [{ id: "fuel", qty: 2 }, { id: "copper", qty: 15 }, { id: "hull_debris", qty: 10 }],
    unlockResearch: "refinery2" },

  { id: "r5",  name: "Forge Ionized Lens",      output: "ionized_lens",      outputQty: 1, time: 20,
    inputs: [{ id: "fuel", qty: 2 }, { id: "copper", qty: 12 }, { id: "glass_shard", qty: 12 }],
    unlockResearch: "refinery2" },

  { id: "r6",  name: "Forge Reinforced Frame",  output: "reinforced_frame",  outputQty: 1, time: 25,
    inputs: [{ id: "metal_alloy", qty: 2 }, { id: "hull_debris", qty: 15 }, { id: "glass_shard", qty: 10 }],
    unlockResearch: "refinery2" },

  { id: "r7",  name: "Forge Plated Wiring",     output: "plated_wiring",     outputQty: 1, time: 25,
    inputs: [{ id: "metal_alloy", qty: 2 }, { id: "hull_debris", qty: 12 }, { id: "copper", qty: 12 }],
    unlockResearch: "refinery2" },

  { id: "r8",  name: "Forge Optical Processor", output: "optical_processor", outputQty: 1, time: 25,
    inputs: [{ id: "synth_alloy", qty: 2 }, { id: "glass_shard", qty: 15 }, { id: "copper", qty: 10 }],
    unlockResearch: "refinery2" },

  { id: "r9",  name: "Forge Pressure Valve",    output: "pressure_valve",    outputQty: 1, time: 25,
    inputs: [{ id: "synth_alloy", qty: 2 }, { id: "glass_shard", qty: 12 }, { id: "hull_debris", qty: 12 }],
    unlockResearch: "refinery2" },

  // ══════════════════════════════════════════════════════════════════════════
  // TIER 2 REFINED — Unlocked when the primary T2 base mat is discovered
  // ══════════════════════════════════════════════════════════════════════════

  { id: "r10", name: "Forge Nano-Glass",      output: "nano_glass",      outputQty: 1, time: 30,
    inputs: [{ id: "silica_dust", qty: 15 }, { id: "glass_shard", qty: 8 }],
    unlockMat: "silica_dust" },

  { id: "r11", name: "Forge Titanium Plates", output: "titanium_plates", outputQty: 1, time: 35,
    inputs: [{ id: "titanium_ore", qty: 15 }, { id: "metal_alloy", qty: 3 }],
    unlockMat: "titanium_ore" },

  { id: "r12", name: "Forge Enriched Cells",  output: "enriched_cells",  outputQty: 1, time: 40,
    inputs: [{ id: "isotope8", qty: 12 }, { id: "fuel", qty: 3 }],
    unlockMat: "isotope8" },

  // ══════════════════════════════════════════════════════════════════════════
  // TIER 2 COMPONENTS — Unlocked by refinery3
  // ══════════════════════════════════════════════════════════════════════════

  { id: "r13", name: "Forge Warp Coolant",     output: "warp_coolant",     outputQty: 1, time: 60,
    inputs: [{ id: "nano_glass", qty: 2 }, { id: "titanium_plates", qty: 2 }, { id: "fuel", qty: 4 }],
    unlockResearch: "refinery3" },

  { id: "r14", name: "Forge Kinetic Shielding",output: "kinetic_shielding", outputQty: 1, time: 75,
    inputs: [{ id: "titanium_plates", qty: 3 }, { id: "reinforced_frame", qty: 2 }, { id: "enriched_cells", qty: 2 }],
    unlockResearch: "refinery3" },

  { id: "r15", name: "Forge Neural Link",      output: "neural_link",      outputQty: 1, time: 90,
    inputs: [{ id: "nano_glass", qty: 3 }, { id: "enriched_cells", qty: 3 }, { id: "optical_processor", qty: 2 }],
    unlockResearch: "refinery3" },

  // ══════════════════════════════════════════════════════════════════════════
  // TIER 3 REFINED — Unlocked when the primary T3 base mat is discovered
  // ══════════════════════════════════════════════════════════════════════════

  { id: "r16", name: "Forge Void Matter", output: "void_matter", outputQty: 1, time: 90,
    inputs: [{ id: "dark_matter", qty: 20 }, { id: "synth_alloy", qty: 5 }],
    unlockMat: "dark_matter" },

  { id: "r17", name: "Forge Bio-Steel",   output: "bio_steel",   outputQty: 1, time: 120,
    inputs: [{ id: "living_metal", qty: 18 }, { id: "metal_alloy", qty: 4 }, { id: "titanium_plates", qty: 3 }],
    unlockMat: "living_metal" },

  { id: "r18", name: "Forge Star-Fire",   output: "star_fire",   outputQty: 1, time: 120,
    inputs: [{ id: "plasma_condensate", qty: 15 }, { id: "enriched_cells", qty: 4 }, { id: "thermal_core", qty: 2 }],
    unlockMat: "plasma_condensate" },

  // ══════════════════════════════════════════════════════════════════════════
  // TIER 3 COMPONENTS — Unlocked by refinery4
  // ══════════════════════════════════════════════════════════════════════════

  { id: "r19", name: "Forge Dimensional Tank",  output: "dimensional_tank",  outputQty: 1, time: 180,
    inputs: [{ id: "void_matter", qty: 4 }, { id: "kinetic_shielding", qty: 3 }, { id: "neural_link", qty: 3 }],
    unlockResearch: "refinery4" },

  { id: "r20", name: "Forge Self-Healing Hull", output: "self_healing_hull", outputQty: 1, time: 210,
    inputs: [{ id: "bio_steel", qty: 4 }, { id: "reinforced_frame", qty: 4 }, { id: "warp_coolant", qty: 3 }],
    unlockResearch: "refinery4" },

  // ══════════════════════════════════════════════════════════════════════════
  // ENDGAME — Unlocked by refinery5
  // ══════════════════════════════════════════════════════════════════════════

  { id: "r21", name: "Forge Quantum Core", output: "quantum_core", outputQty: 1, time: 600,
    inputs: [
      { id: "void_matter",      qty: 5 },
      { id: "bio_steel",        qty: 4 },
      { id: "star_fire",        qty: 4 },
      { id: "dimensional_tank", qty: 2 },
    ],
    unlockResearch: "refinery5" },
];
